import React, { useContext, useEffect } from "react";

import AppContext from "../../context/AppContext";
import { SIDER_TABS } from "../../utils/Constants";
import { AppStrings } from "../../utils/constants/AppStrings";
import { usePageTitle } from "../CommonComponents/Layout/PageTitleContext";
import EventsList from "./EventsList/EventsList";

/**
 * Fieldbook entry point: same Events List as legacy Sportsbook, under its own route.
 */
const FieldbookEventsList: React.FC = () => {
  usePageTitle(AppStrings.EVENTS_LIST);
  const { setActiveSidebarTab } = useContext(AppContext);

  useEffect(() => {
    // Match the SPORTSBOOK_OPTIONS leaf labelKey so the entry stays highlighted
    // while the user is on Events List.
    setActiveSidebarTab(SIDER_TABS.SPORTSBOOK, "EVENTS_LIST");
  }, [setActiveSidebarTab]);

  return (
    <>
      <EventsList />
    </>
  );
};

export default FieldbookEventsList;
